module.exports = __webpack_public_path__ + "static/media/mail-bulk.5332184f.svg";